/**
 * Who may change the hiring process.
 *
 * Recruiting is the recruiter's job. An admin, manager or team lead reads the
 * pipeline and the reporting — the same pages, without the buttons that write.
 * The server enforces this too; hiding the controls just avoids offering an
 * action that would be refused.
 */
export const canRecruit = (user) => user?.role === 'recruiter';

/**
 * Who may post a job. A recruiter posts their own; a team lead posts one,
 * keeps it or assigns it to a recruiter in their team, and can reassign later.
 */
export const canCreateJob = (user) => ['recruiter', 'team_lead'].includes(user?.role);

/**
 * Who may work a job — edit it, handle its candidates, schedule interviews:
 * the person it is assigned to, a recruiter or a team lead who kept it.
 * A team lead only views the jobs they assigned to their recruiters.
 */
export const canWorkJob = (user, job) =>
  ['recruiter', 'team_lead'].includes(user?.role) && Boolean(job) && job.assigned_to_id === user?.id;

/** Why a control is disabled, for a title/tooltip. */
export const VIEW_ONLY_HINT =
  'View only — only a recruiter can change the recruitment process.';
